import { toast, ToastOptions } from 'react-toastify';

interface Toaster {
  success: (message: string, options?: ToastOptions) => void;
  error: (message: string, options?: ToastOptions) => void;
  info: (message: string, options?: ToastOptions) => void;
  warn: (message: string, options?: ToastOptions) => void;
}

export const toaster: Toaster = {
  success: (message, options = {}) => {
    toast.success(message, {
      ...options,
      className: 'custom-toast-success',
      bodyClassName: 'custom-toast-body-success',
      progressClassName: 'custom-toast-progress-success',
    });
  },
  error: (message, options = {}) => {
    toast.error(message, {
      ...options,
      className: 'custom-toast-error',
      bodyClassName: 'custom-toast-body-error',
      progressClassName: 'custom-toast-progress-error',
    });
  },
  info: (message, options = {}) => {
    toast.info(message, {
      ...options,
      className: 'custom-toast-info',
      bodyClassName: 'custom-toast-body-info',
      progressClassName: 'custom-toast-progress-info',
    });
  },
  warn: (message, options = {}) => {
    toast.warn(message, {
      ...options,
      className: 'custom-toast-warning',
      bodyClassName: 'custom-toast-body-warning',
      progressClassName: 'custom-toast-progress-warning',
    });
  },
};

export default toaster;
